import { render } from "./UnitCurrentStage.vue?vue&type=template&id=0536aec0&scoped=true"
import script from "./UnitCurrentStage.vue?vue&type=script&lang=js"
export * from "./UnitCurrentStage.vue?vue&type=script&lang=js"

import "./UnitCurrentStage.vue?vue&type=style&index=0&id=0536aec0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0536aec0"]])

export default __exports__